import { useState } from 'react';
/* eslint-disable */
import { classes, convertWeightUnit, getUnitConvertedQuantity, getUnitConvertedUnit } from '../../../../../Helpers';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Typography } from '@mui/material';
import styles from './CMSRecipeItemsList.module.scss';

function BuildItem(props) {
	const { data, onClick, isSelected, isCms, unit, recipe, combineCMSBatches } = props;
	const [errorMsg, setErrorMsg] = useState('');
	const convertedConsumption = getUnitConvertedQuantity(data?.consumption, ['count', 'pcs'].includes(data?.unit) ? 'gram' : data?.unit, true, true, true);
	const convertedConsumptionUnit = getUnitConvertedUnit(
		data?.consumption,
		['count', 'pcs'].includes(data?.unit) ? 'gram' : data?.unit,
		true,
	);

	const convertedRequired = getUnitConvertedQuantity(
		data?.requiredQty,
		['count', 'pcs'].includes(data?.unit) ? 'gram' : data?.unit,
		true,
		true,
		true
	);
	const convertedRequiredUnit = getUnitConvertedUnit(
		data?.requiredQty,
		['count', 'pcs'].includes(data?.unit) ? 'gram' : data?.unit,
		true,
	);
	const convertedOrderd = getUnitConvertedQuantity(
		data?.ingTotalQty,
		data?.unit,
		true,
		true,
		true
	);
	const convertedOrderdUnit = getUnitConvertedUnit(
		data?.ingTotalQty,
		data?.unit,
		true,
	);

	return (
		<div
			onClick={onClick}
			className={classes(
				styles.item,
				data?.isConsumed ? styles.doneGreen : '',
				isSelected ? styles.selected : ''
			)}
		>
			<div className={styles.img}>
				<span className={styles.completedText}>
					{(isCms && combineCMSBatches) ?
						(data?.consumption >= 0
							? `${data?.unit === 'count' ? (data?.piecesCount ?? 0) + ' pc' : (Number(convertedConsumption) || 0).toFixed(2)}/`
							: '') + (data?.unit === 'count' ? (data?.ingTotalQty || 0) + ' pc' : `${(Number(convertedOrderd) || 0).toFixed(2)} ${convertedOrderdUnit}`)
						:
						(data?.consumption >= 0
							? ` ${(Number(convertedConsumption) || 0).toFixed(2)} ${convertedConsumptionUnit}/`
							: '') + `${(Number(convertedRequired) || 0).toFixed(2)} ${convertedRequiredUnit}`
					}
				</span>
				{data?.image && !errorMsg ? (
					<img
						style={{
							width: '100%',
							height: 'auto',
							objectFit: 'cover',
							borderRadius: '4px',
						}}
						src={data?.image}
						alt='prblm showing'
						onError={async () => {
							try {
								const res = await fetch(data.image, { method: 'HEAD' });
								if (!res.ok) {
									setErrorMsg(`Error ${res.status}`);
								} else {
									setErrorMsg('Corrupted');
								}
							} catch (e) {
								setErrorMsg('Blocked/CORS');
							}
						}}
					/>
				) : (
					<div
						style={{
							width: '100%',
							height: '100%',
							display: 'flex',
							flexDirection: 'column',
							alignItems: 'center',
							justifyContent: 'center',
							backgroundColor: '#333',
							borderRadius: '4px',
							border: '1px dashed #666',
							padding: '4px'
						}}
					>
						<InfoOutlinedIcon style={{ fontSize: 20, color: '#999', marginBottom: '2px' }} />
						<Typography
							variant='caption'
							style={{
								fontSize: '9px',
								color: '#aaa',
								lineHeight: '1.1',
								textAlign: 'center'
							}}
						>
							{!data?.image ? 'No Source' : errorMsg}
						</Typography>
					</div>
				)}
			</div>
			<div className={styles.name}>
				<span>{data?.name}</span>
			</div>
		</div>
	);
}

function CMSRecipeItemsList(props) {
	const { ingredients, onClick, currentRecipe, getPastQCDetails, isCms, unit, recipe, combineCMSBatches } = props;
	// const [current, setCurrent] = useState(0);

	return (
		<div className={styles.root}>
			<div className={styles.list}>
				{ingredients?.map((data) => {
					return (
						<BuildItem
							onClick={() => {
								onClick(data);
								getPastQCDetails(data?.qcId);
							}}
							isSelected={currentRecipe?.id === data?.id}
							data={data}
							isCms={isCms}
							unit={unit}
							recipe={recipe}
							combineCMSBatches={combineCMSBatches}
						/>
					);
				})}
			</div>
		</div>
	);
}

export default CMSRecipeItemsList;
